import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { RequestAccessPageComponent } from './request-access-page/request-access-page.component';
import { ButtonModule } from 'src/app/shared/components/button/button.module';
import { InputModule } from 'src/app/shared/components/input/input.module';
import { NgxCaptchaModule } from 'ngx-captcha';
import { HttpClient, HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AppHttpInterceptor } from 'src/app/core/interceptors/AppHttpInterceptor';
import { TranslateModule } from '@ngx-translate/core';
import { RouterModule } from '@angular/router';

@NgModule({
  declarations: [RequestAccessPageComponent],
  providers: [HttpClient, { provide: HTTP_INTERCEPTORS, useClass: AppHttpInterceptor, multi: true }],
  imports: [
    CommonModule,
    ButtonModule,
    InputModule,
    NgxCaptchaModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    TranslateModule,
    RouterModule
  ]
})
export class RequestAccessPageModule {}
